<template>
	<f7-page class="nutrition-detail">
		<navbar
			:text="`${currentPlantation.company} > ${
				currentPlantation.explotation
			} > ${currentPlantation.parcel} > ${currentPlantation.sector} > ${
				currentPlantation.name
			} > ${$t('Utilities.nutrition')}`" />

		<ModalCopyReferencePlan
			:id="id"
			:visible="ShowModal"
			type="nutrition"
			@close="ShowModal = false"
			@copy="copy" />

		<Placeholder v-if="!dataLoaded" :is-new="isNew" />

		<nutrition-detail-component
			v-if="dataLoaded"
			:fertilization="fertilization"
			:plantation-property="actualPlantation"
			@open-copy-modal="ShowModal = true" />
		<f7-row no-gap>
			<f7-col style="align-self: stretch">
				<element-resume-component
					v-if="!isNew && dataLoaded"
					class="element-resume"
					:fertilization="fertilization" />
				<ElementResumeComponentNew
					v-if="isNew && dataLoaded"
					class="element-resume"
					:fertilization="fertilization" />
			</f7-col>
			<f7-col>
				<product-resume-chart-component
					v-if="dataLoaded"
					:fertilization="fertilization" />
			</f7-col>
		</f7-row>
		<ProductResumeComponent
			v-if="dataLoaded"
			:plantationData="[actualPlantation]"
			:fertilization="fertilization" />

		<ProductResumeTable v-if="dataLoaded" :fertilization="fertilization" />

		<IrrigationResumeTable
			v-if="dataLoaded && !showIrrigationTable && showOldIrrigationTable"
			:fertilization="fertilization" />

		<ApplicationEfficiencyPerPeriod
			v-if="isNew && dataLoaded"
			:fertilization="fertilization" />

		<div class="content-devx margin-half" style="padding: 0">
			<div style="padding: 4px">
				<div class="main-title-content" style="padding: 9px">
					CALENDARIO DE RIEGO Y FERTIRRIGACIÓN
				</div>
				<div>
					<div v-if="fertilization.period == 'DIARIO'" class="card-body main">
						<section
							id="irrgation-calendar-section"
							class="irrigation-calendars">
							<div
								id="calendar-irrigation-section"
								class="irrigation-calendars__item">
								<CalendarViewer
									:startDate="fertilization.init_date"
									:endDate="fertilization.end_date"
									:customDatesOne="irrigationDates"
									:customDatesTwo="fertirrigationDates" />
							</div>
							<div class="irrigation-calendars__item">
								<div class="calendar-legend">
									<span class="calendar-legend__item">
										<span
											class="calendar-legend__color calendar-legend__color--irrigation"></span>
										Días con riego
									</span>
									<span class="calendar-legend__item">
										<span
											class="calendar-legend__color calendar-legend__color--fertilization"></span>
										Días con fertilización
									</span>
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>

		<PaoResume v-if="dataLoaded" :fertilization="fertilization" />

		<Observations v-if="dataLoaded" :fertilization="fertilization" />

		<section class="margin-half margin-bottom">
			<f7-button
				class="dx-btn-cancel btnBack"
				type="default"
				text-color="grey"
				styling-mode="outlined"
				name="ButtonCancel"
				@click="back">
				{{ $t('Button_go_to_back') }}
			</f7-button>
		</section>
	</f7-page>
</template>
<script>
	import moment from 'moment';
	import { mapActions, mapState } from 'vuex';
	import navbar from '../../../components/NavBar.vue';
	import nutritionDetailComponent from '../../../components/nutritionDetail/nutritionDetail/index.vue';
	import elementResumeComponent from '../../../components/nutritionDetail/elementResume/index.vue';
	import ElementResumeComponentNew from '../../../components/nutritionDetail/elementResume/new.vue';
	import ProductResumeTable from '../../../components/nutritionDetail/productResumeTable/index.vue';
	import IrrigationResumeTable from '../../../components/nutritionDetail/irrigationResumeTable/index.vue';
	import ProductResumeComponent from '../../../components/productResume/ProductResume.vue';
	import productResumeChartComponent from '../../../components/nutritionDetail/productResumeChart/index.vue';
	import Observations from '../../../components/nutritionDetail/observations/index.vue';
	import PaoResume from '../../../components/nutritionDetail/paoResume/index.vue';
	import ApplicationEfficiencyPerPeriod from '../../../components/nutritionDetail/ApplicationEfficiencyPerPeriod/index.vue';
	import Placeholder from '../../../components/nutritionDetail/Placeholder/index.vue';
	import fertilizationService from '@/services/fertilizationService';
	import ModalCopyReferencePlan from '../../../components/utilities/referencePlans/detail/ModalCopyReferencePlan.vue';
	import Api from '../../../services/Api';
	import { mapGetters } from 'vuex/dist/vuex.common.js';
	import CalendarViewer from '../../../components/CalendarViewer/CalendarViewer.vue';

	export default {
		name: 'NutritionDetailWizard',
		components: {
			navbar,
			nutritionDetailComponent,
			elementResumeComponent,
			ProductResumeTable,
			ElementResumeComponentNew,
			ProductResumeComponent,
			IrrigationResumeTable,
			productResumeChartComponent,
			Observations,
			PaoResume,
			ApplicationEfficiencyPerPeriod,
			Placeholder,
			ModalCopyReferencePlan,
			CalendarViewer,
		},
		props: ['id'],
		data() {
			return {
				fertilization: {},
				dataLoaded: false,
				ShowModal: false,
				showOldIrrigationTable: false,
				irrigationDates: [],
				fertirrigationDates: [],
			};
		},
		computed: {
			showIrrigationTable() {
				return (
					(this.fertilization?.periods_irrigation &&
						this.fertilization.periods_irrigation.every(
							(value) => value === 0,
						)) ??
					true
				);
			},
			...mapState('RegisterPlantation', ['actualPlantation']),
			...mapState('Plantation', ['currentPlantation']),
			...mapState('nutritionStepper', ['isNew']),
			...mapGetters('nutritionStepper', [
				'nutritionIrrigationData',
				'stepData',
			]),
		},
		async mounted() {
			this.dataLoaded = false;
			await fertilizationService
				.getById(this.id, this.currentPlantation.companyId)
				.then((response) => {
					const newPlan = response?.version === '2.2.0';
					this.setIsNew(newPlan);

					this.fertilization = response;
					this.showOldIrrigationTable = this.fertilization.old_irrigation_table;
				});
			await fertilizationService
				.getById(this.id, this.currentPlantation.companyId, true)
				.then((response) => {
					this.setStepNutritionIrrigationData(response);
				});
			this.dataLoaded = true;
			this.getIrrigationDatesFromNutritionData();
		},
		methods: {
			...mapActions('nutritionStepper', [
				'setIsNew',
				'setStepNutritionIrrigationData',
			]),
			async copy(date) {
				const planDuration =
					moment(this.fertilization.end_date).diff(
						moment(this.fertilization.init_date),
						'days',
					) || 0;

				const xhr = await Api.getPlantationById(
					this.fertilization.company_id,
					this.fertilization.plantation,
				);
				const plantation = JSON.parse(xhr.response);

				this.$f7router.navigate({
					name: 'nutrition-plans-copy',
					params: {
						id: this.id,
					},
					query: {
						date,
						duration: planDuration,
						species: plantation.species,
					},
				});
			},
			back() {
				this.$f7.views.main.router.navigate('/searcher/nutrition/', {
					reloadCurrent: true,
				});
			},
			getIrrigationDatesFromNutritionData() {
				// Limpia los arrays antes de llenarlos para evitar duplicados si se llama varias veces
				this.irrigationDates = [];
				this.fertirrigationDates = [];

				if (
					this.nutritionIrrigationData &&
					Array.isArray(this.nutritionIrrigationData.data)
				) {
					this.nutritionIrrigationData.data.forEach((yearObj) => {
						yearObj.items.forEach((monthObj) => {
							Object.entries(monthObj.dates).forEach(([date, info]) => {
								// Convierte la fecha de "DD/MM/YYYY" a "YYYY-MM-DD"
								const [day, month, year] = date.split('/');
								const formattedDate = `${year}-${month.padStart(
									2,
									'0',
								)}-${day.padStart(2, '0')}`;

								// Verifica si hay dosis o totales en algún producto
								const hasDoseOrTotal =
									Array.isArray(info.products) &&
									info.products.some(
										(prod) =>
											(prod.dosis !== null &&
												prod.dosis !== undefined &&
												!isNaN(prod.dosis) &&
												Number(prod.dosis) > 0) ||
											(prod.totales !== null &&
												prod.totales !== undefined &&
												!isNaN(prod.totales) &&
												Number(prod.totales) > 0),
									);

								// Fechas con solo riego (sin dosis ni totales)
								if (info.irrigation_time && !hasDoseOrTotal) {
									this.irrigationDates.push(formattedDate);
								}

								// Fechas con dosis o totales (independientemente de si hay riego)
								if (hasDoseOrTotal) {
									this.fertirrigationDates.push(formattedDate);
								}
							});
						});
					});
				}
				return {
					datesWithIrrigation: this.irrigationDates,
					datesWithDoseOrTotal: this.fertirrigationDates,
				};
			},
		},
	};
</script>
<style src="./nutrition-detail.scss" scoped lang="scss"></style>
